/** @format */
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    InputSignal,
    Signal,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
    SelectCourseUnitsModalComponent,
    selectCourseUnitsModalOpener,
    SelectCourseUnitsModalValues,
} from '../../../select-course-units-modal/select-course-units-modal.component';
import {
    isTimelineCourseUnit,
    isTimelineCustomCourseUnitAttainment,
    isTimelineCustomStudyDraft,
    StudyPeriodData,
} from '../../../timing.types';

export type TimelineStudyPeriodHeadingLevel = 1 | 2 | 3 | 4 | 5;
export type TimelineStudyPeriodChildHeadingLevel = 2 | 3 | 4 | 5 | 6;

@Component({
    selector: 'app-timeline-study-period',
    standalone: false,
    templateUrl: './timeline-study-period.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineStudyPeriodComponent {
    readonly period: InputSignal<StudyPeriodData> = input.required<StudyPeriodData>();
    readonly headingLevel: InputSignal<TimelineStudyPeriodHeadingLevel> = input.required<TimelineStudyPeriodHeadingLevel>();

    protected readonly childHeadingLevel: Signal<TimelineStudyPeriodChildHeadingLevel> = computed(
        () => <TimelineStudyPeriodChildHeadingLevel>(this.headingLevel() + 1),
    );

    private readonly viewContainerRef = inject(ViewContainerRef);

    protected readonly isTimelineCourseUnit = isTimelineCourseUnit;
    protected readonly isTimelineCustomCourseUnitAttainment = isTimelineCustomCourseUnitAttainment;
    protected readonly isTimelineCustomStudyDraft = isTimelineCustomStudyDraft;

    private readonly selectCourseUnitsModalOpener: (
        data: SelectCourseUnitsModalValues,
        viewContainerRef: ViewContainerRef,
    ) => MatDialogRef<SelectCourseUnitsModalComponent, null> = selectCourseUnitsModalOpener();

    protected openSelectCourseUnitsModal(): void {
        this.selectCourseUnitsModalOpener({ studyPeriodData: this.period() }, this.viewContainerRef);
    }
}
